import React, { Component } from "react";
import Core from "Core";
import { observer, Provider } from "mobx-react";
import { Modal } from "react-bootstrap";

class OpenModal extends Component {
  onHide() {
    const { handler } = this.props;
    handler.close();
  }

  render() {
    const { handler } = this.props;

    let { title, glyph, modalProps, props } = handler;

    if (!modalProps) modalProps = {};
    if (!props) props = {};

    const { backdrop } = modalProps;
    const closeButton = backdrop !== "static";

    return (
      <Modal show {...modalProps} onHide={this.onHide.bind(this)}>
        <Core.Components.ModalParts.Header
          title={title}
          glyph={glyph}
          closeButton={closeButton}
        />
        <Provider handler={handler}>
          <handler.component {...props} />
        </Provider>
      </Modal>
    );
  }
}

export default observer(OpenModal);



// WEBPACK FOOTER //
// ./src/Core/Components/OpenModals/OpenModal.js